module.exports = __webpack_public_path__ + "static/img/Ashcroft_W.47fb693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ashcroft_W.jpg
// module id = w+mo
// module chunks = 0